import React from "react";
import PropTypes from "prop-types";
import { Typography, useTheme, Box, Skeleton } from "@mui/material";
import { Item } from "./Item";
import { gridClasses } from "@mui/x-data-grid";

const CardDashboardItem = ({
  title,
  content,
  isLoading = false,
  height = "300px",
}) => {
  const theme = useTheme();
  const resolveHeightValue = (value) =>
    typeof value === "number" ? `${value}px` : value;
  const resolvedHeight = resolveHeightValue(height);
  
  return (
    <Item
      sx={{
        display: "flex",
        flexDirection: "column",
        height: height === "100%" ? "100%" : resolvedHeight || "auto",
        maxHeight: "auto",
        minHeight: height === "100%" ? "100%" : resolvedHeight || "400px",
        padding: "1rem",
        margin: 0,
      }}
    >
      {/* Title at the top left */}
      {title && (
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: theme.palette.primary.text2,
            margin: 0,
            padding: 0,
            alignSelf: "flex-start",
          }}
        >
          {title}
        </Typography>
      )}

      <Box
        sx={{
          py: title ? ".5rem" : 0,
        }}
      />

      {/* Content taking the rest with no padding */}
      {isLoading ? (
        <Box
          sx={{
            flex: 1,
            width: "100%",
            height: height || "500px",
          }}
        >
          <Skeleton
            variant="rectangular"
            height={height || "500px"}
            width="100%"
            animation="wave"
            sx={{
              borderRadius: "12px",
              backgroundColor: theme.palette.background.default,
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            padding: 0,
            margin: 0,
            width: "100%",
            minHeight: 0,
            height: height === "100%" ? "100%" : resolvedHeight || "auto",

            [`.${gridClasses.cell}`]: {
              color: theme.palette.primary.text,
            },
            [`.${gridClasses.cell}.notAvailable`]: {
              color: theme.palette.primary.text3,
            },
            "& ::-webkit-scrollbar-track": {
              margin: "0 0 0 0",
            },
          }}
        >
          {content}
        </Box>
      )}
    </Item>
  );
};

CardDashboardItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CardDashboardItem;
